import { useState } from "react";
import { rankHot, rankWeek, rankRising, type HotItem } from "@/mocks/chigua";

const tabs = [
  { key: "hot", label: "实时热榜", data: rankHot },
  { key: "week", label: "本周热议", data: rankWeek },
  { key: "rise", label: "正在上升", data: rankRising },
];

function heatBar(rank: number, value: number) {
  return {
    width: `${Math.max(20, 100 - (rank - 1) * 6)}%`,
    label: value,
  };
}

export default function RankingSection() {
  const [active, setActive] = useState("hot");
  const current = tabs.find((t) => t.key === active)!.data;

  return (
    <section id="ranking" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-fire-line" aria-hidden="true"></i>
              吃瓜入口索引
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">全站热搜总榜</h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              吃瓜入口大全中最受关注的栏目之一，追踪全平台当下讨论度最高的事件，按热度实时排列，跟着榜单走就不会错过重点。
            </p>
          </div>

          <div className="flex w-full max-w-md items-center gap-1 rounded-full border border-background-200/70 bg-background-50 p-1 md:w-auto">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setActive(t.key)}
                className={`flex-1 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors md:flex-none ${active === t.key ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:bg-background-100"}`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-6">
            <ol className="flex flex-col gap-1">
              {current.slice(0, 5).map((item: HotItem) => (
                <li key={`${active}-a-${item.rank}`}>
                  <div className="group flex items-center gap-3 rounded-lg p-2 transition-colors hover:bg-background-100">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${item.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700 ring-1 ring-background-200"}`}>
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">{item.title}</p>
                      <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-background-100">
                        <div className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-500" style={{ width: heatBar(item.rank, item.heat).width }}></div>
                      </div>
                    </div>
                    <span className="hidden shrink-0 whitespace-nowrap text-xs text-foreground-500 sm:inline-block">{item.heat}万热度</span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-6">
            <ol className="flex flex-col gap-1">
              {current.slice(5, 10).map((item: HotItem) => (
                <li key={`${active}-b-${item.rank}`}>
                  <div className="group flex items-center gap-3 rounded-lg p-2 transition-colors hover:bg-background-100">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-sm font-bold text-foreground-700 ring-1 ring-background-200">
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">{item.title}</p>
                      <span className="mt-0.5 inline-flex whitespace-nowrap text-xs text-foreground-500">来自 {item.channel}</span>
                    </div>
                    <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 sm:inline-block">{item.tag}</span>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>

        <p className="mt-5 text-xs text-foreground-500">
          <i className="ri-information-line" aria-hidden="true"></i>
          热度值为综合各平台讨论量、转发量与话题量的估算指数，仅用于反映相对热度，帮助按图索骥定位重点。
        </p>
      </div>
    </section>
  );
}